import { render, staticRenderFns } from "./MedRecord.vue?vue&type=template&id=623946b5&scoped=true"
import script from "./MedRecord.vue?vue&type=script&lang=js"
export * from "./MedRecord.vue?vue&type=script&lang=js"
import style0 from "./MedRecord.vue?vue&type=style&index=0&id=623946b5&lang=scss&scoped=true"
import style1 from "./MedRecord.vue?vue&type=style&index=1&id=623946b5&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623946b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623946b5')) {
      api.createRecord('623946b5', component.options)
    } else {
      api.reload('623946b5', component.options)
    }
    module.hot.accept("./MedRecord.vue?vue&type=template&id=623946b5&scoped=true", function () {
      api.rerender('623946b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/health/MedRecord.vue"
export default component.exports